<svg enable-background="new 0 0 0 0" id="L5" version="1.1" viewBox="0 0 100 100" x="0px"
     xml:space="preserve" xmlns="http://www.w3.org/2000/svg" y="0px" *ngIf="loader">
  <defs>
    <linearGradient
      [attr.x1]="loader.linearGradientPosition.x1"
      [attr.x2]="loader.linearGradientPosition.x2"
      [attr.y1]="loader.linearGradientPosition.y1"
      [attr.y2]="loader.linearGradientPosition.y2"
      id="linear">
      <stop *ngFor="let stop of loader.gradientColorValues" [attr.offset]="stop.position"
            [attr.stop-color]="stop.color"/>
    </linearGradient>
    <radialGradient [attr.fx]="loader.radialGradientPosition.x"
                    [attr.fy]="loader.radialGradientPosition.y"
                    id="radial">
      <stop *ngFor="let stop of loader.gradientColorValues" [attr.offset]="stop.position"
            [attr.stop-color]="stop.color"/>
    </radialGradient>
  </defs>
  <circle [attr.fill]="loader.color" cx="6" cy="50" r="6" stroke="none">
    <animateTransform
      attributeName="transform"
      begin="0.1"
      dur="1s"
      repeatCount="indefinite"
      type="translate"
      values="0 15 ; 0 -15; 0 15"/>
  </circle>
  <circle [attr.fill]="loader.color" cx="30" cy="50" r="6" stroke="none">
    <animateTransform
      attributeName="transform"
      begin="0.2"
      dur="1s"
      repeatCount="indefinite"
      type="translate"
      values="0 15 ; 0 -15; 0 15"/>
  </circle>
  <circle [attr.fill]="loader.color" cx="54" cy="50" r="6" stroke="none">
    <animateTransform
      attributeName="transform"
      begin="0.3"
      dur="1s"
      repeatCount="indefinite"
      type="translate"
      values="0 15 ; 0 -15; 0 15"/>
  </circle>
</svg>
